var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cards qb-container qb-margin-bottom",class:_vm.setSize,staticStyle:{"width":"100%"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }